var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9994 15.9738V18.9846C22.0005 19.2642 21.9403 19.5408 21.8225 19.7969C21.7047 20.053 21.5319 20.2829 21.3152 20.4719C21.0985 20.6608 20.8427 20.8047 20.5642 20.8942C20.2856 20.9838 19.9904 21.017 19.6975 20.9919C16.4484 20.6563 13.3275 19.601 10.5853 17.9108C8.03418 16.3699 5.87123 14.3141 4.2501 11.8892C2.46565 9.27099 1.35515 6.29008 1.00857 3.18795C0.982184 2.91042 1.01689 2.63071 1.11046 2.36663C1.20404 2.10254 1.35444 1.85987 1.5521 1.65407C1.74975 1.44826 1.99033 1.28383 2.2585 1.17123C2.52668 1.05864 2.81659 1.00036 3.10976 1.0001H6.27738C6.78981 0.995304 7.28658 1.16778 7.67511 1.48537C8.06364 1.80297 8.31741 2.24401 8.38913 2.72629C8.52283 3.68982 8.77078 4.63587 9.12824 5.54642C9.2703 5.90563 9.30105 6.29602 9.21684 6.67133C9.13263 7.04665 8.93699 7.39115 8.6531 7.66402L7.31214 8.93859C8.81524 11.4512 11.004 13.5315 13.6474 14.9602L14.9883 13.6856C15.2754 13.4158 15.6379 13.2298 16.0327 13.1498C16.4276 13.0698 16.8383 13.099 17.2162 13.234C18.1742 13.5738 19.1695 13.8095 20.1832 13.9365C20.6962 14.0053 21.1646 14.2509 21.4994 14.6265C21.8343 15.0021 22.0122 15.4817 21.9994 15.9738Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.276318e43f817f440808f1999af821ac.svg";
export { ForwardRef as ReactComponent };